<app-page-meta pageTitle="Low Interest Personal Loans | Get easy loans online in India - finzy"
               tags="quick personal loans, low interest personal loans, easy loans online, personal loans, cheapest loans india, peer to peer lending, peer to peer lending india, line of credit online, easy finance, need a loan, india credit finance, current loan rates india, best loans india, best loan rates"
               description="Get the cheapest loans in India to fund your next purchase. Finzy provides you quick personal loans at interest rates as low as 7.99%. Know more about these collateral free, easy loans online with the quickest turnaround time. Finzy connects personal loan borrowers with investors.">
</app-page-meta>

<app-header></app-header>

<div class="page-content">
  <div class="container-fluid">
    <section class="row banner">
      <div class="col-xs-12 banner-container">
        <div class="campaign-banner">
          <div class="row banner">
            <div class="col-md-5 col-xs-11 left-section left-section">
              <img id="finzy-logo" alt="finzy logo - Home" src="../../../assets/images/finzy-logo-white.png"
                   width="130">

              <div class="description text-uppercase text-white xx-big-text">
                <p class="text-white banner-header">Quick Personal Loans</p>
                <p class="text-white banner-header">Low Interest Rates</p>
              </div>

              <div class="description text-uppercase text-white x-big-text">
                <ul class="checklist-white">
                  <li>No hidden charges.</li>
                  <li>Quick turn around time.</li>
                  <li>No lock-in. No prepayment charges.</li>
                </ul>
              </div>
            </div>

            <div class="enquire-now-section col-md-5 col-md-offset-1">
              <p class="enquire-now-title">Enquire about a finzy loan</p>
              <p class="enquire-now-subtitle">Please provide your information below and we will get in touch with you.</p>

              <app-borrower-enquire-now-form></app-borrower-enquire-now-form>
            </div>

            <a class="col-lg-12 visible-lg know-more-text"
               [href]="getCurrentUrl()+'#section-why-finzy'">KNOW MORE
              <br/>
              <span class="glyphicon glyphicon-chevron-down"></span></a>
          </div>
        </div>
      </div>
    </section>

    <app-why-finzy-section class="super-row display-block"></app-why-finzy-section>
    <app-eligibility-criteria-section
      class="super-row display-block grey-section bottom-cut"></app-eligibility-criteria-section>
    <app-how-it-works-section class="super-row display-block grey-section"></app-how-it-works-section>
    <app-core-team-section class="super-row display-block"></app-core-team-section>
    <app-borrower-testimonials-section class="super-row display-block grey-section"></app-borrower-testimonials-section>

    <section id="borrow-now" class="row borrow-now">
      <div class="col-xs-12">
        <div class="row borrow-now-content-strip">
          <div class="col-md-6 col-md-offset-1 borrow-now-description">
            <h2 class="description-header">Apply for a quick loan</h2>
            <div>Get a hassle free loan at interest rates starting as low as 7.99%
            </div>
          </div>
          <div class="col-md-3 col-md-offset-1 borrow-now-action">
            <button class="action-button-secondary" routerLink="/borrow"
                    (click)="analyticsTracker.trackButtonClick('Borrower campaign', 'BORROW NOW')">
              Borrow Now
            </button>
          </div>
        </div>
      </div>
    </section>

    <app-campaign-enquire-footer class="display-block" [profileType]="ProfileType.BORROWER"></app-campaign-enquire-footer>
  </div>
</div>
